import { CdkTableModule } from '@angular/cdk/table';
import { Component, Input } from '@angular/core';
import {
  MatLegacyTableDataSource as MatTableDataSource,
  MatLegacyTableModule as MatTableModule,
} from '@angular/material/legacy-table';
import { fuseAnimations } from '@fuse/animations';
import { CuttingCuttedMaterial, CuttingOffcut, NgxLocalizedNumbers } from 'cloud-shared-lib';

@Component({
  selector: 'cutting-used-client-offcuts',
  templateUrl: './used-client-offcuts.component.html',
  standalone: true,
  imports: [NgxLocalizedNumbers, CdkTableModule, MatTableModule],
  animations: fuseAnimations,
})
export class UsedClientOffcutsComponent {
  displayedColumns = ['height', 'width', 'count', 'area'];

  dataSource: MatTableDataSource<CuttingOffcut> = new MatTableDataSource();

  @Input() set material(value: CuttingCuttedMaterial) {
    this.dataSource.data = value.usedOffcuts;
  }
}
